(function($){

	$(document).ready(function(){

		$(document).on('click','.newsletter-form__btn',function(e){
			e.preventDefault();

			var newsletterForm = $(this).parents('.newsletter-form');
		    var newsletterEmail = newsletterForm.find('.newsletter-form__email');
		    var newsletterBtn = newsletterForm.find('.newsletter-form__btn');
		    var newsletterEmailVal = newsletterEmail.val();
		    var checkedItems = newsletterForm.find('.newsletter-form__checkbox:checked');

		    var listOptions = [];

		    checkedItems.each(function(i, e){
		      return listOptions.push($(e).val());
		    });

		    if (!checkEmail(newsletterEmail.val())) {
		      	showNotice('Please enter a valid email!', 'error', newsletterForm);
		      	newsletterEmail.focus();
		    } else if (listOptions.length===0) {
		    	showNotice('Please select a list to subscribe!', 'error', newsletterForm);
		    } else {
		    	newsletterForm.find('.info').remove();
			    newsletterBtn.addClass('processing');
			      
		      	// ajax call to subcribe the newsletter_email
		      	$.ajax({
			        url : user_vars.ajax_url,
			        type : 'POST',
			        data : {
			          action: 'mc_subscribe',
			          lists : listOptions,
			          email : newsletterEmail.val(),
			        },
			        success : function(response) {
			          
			        	if (!!response.success) {
			          				            
			            	var subscriber = response.already_subscribed_to_master;

			            	if(subscriber === true) {
			            		showNotice('You are already subscribed, your mailing lists have been updated.', 'success', newsletterForm);
			            	} else {
			            		showNotice('Thank you for subscribing. Please check your email to validate your sign up.', 'success', newsletterForm);
			            	}

			            	newsletterBtn.removeClass('processing');
			            	newsletterEmail.val('');
			            	newsletterForm.find('.newsletter-form__checkbox').prop('checked', false);

			            	// setTimeout(function(){
			            	// 	$('#newsletterModal').modal('hide');
			            	// }, 2000);

			          	} else {
			            	newsletterBtn.removeClass('processing');
			            	showNotice('response.message', 'error', newsletterForm);
			          	}
			        },
			        error : function( error ) {
			        	showNotice('There was an error!', 'error', newsletterForm);
			        	newsletterBtn.removeClass('processing');
			        }
		      	});
		    } 
		});

	});
	
})(jQuery);

function showNotice(msg, msgtype, newsletterForm) {
	newsletterForm.find('.info').remove();
	const msgDiv = document.createElement('div');
	msgDiv.textContent = msg;
	msgDiv.classList.add('info');
	msgDiv.classList.add(msgtype);
	newsletterForm.append(msgDiv);
}

function checkEmail(email) {
    var filter = /^([\w-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return filter.test(email);
}